export const loadMetricsEvents = () => {
    
    Array.from(document.querySelectorAll('[data-DLdescripcion]'))
        .filter(k => k.getAttribute("data-DLdescripcion") != null &&
            k.getAttribute("data-DLdescripcion") !== "" &&
            k.getAttribute("data-DLdescripcion") !== undefined).map((d) => {
            d.addEventListener("click",
                () => {
                    if (window.dataLayer != undefined && d.getAttribute("class") !== "seguir activo") {
                        if (d.getAttribute("data-preferibletipoid") == 6) {
                            window.dataLayer.push({'event': 'followAuth','followedAuth': d.getAttribute("data-DLdescripcion")});
                        }else if (d.getAttribute("data-preferibletipoid") == 7) {
                            window.dataLayer.push({'event': 'follow','followed': d.getAttribute("data-DLdescripcion")});
                        }
                    }
                });
        });
}

export const eventosMetricas = () => {
    ///TODO agregar otro tipo de evento q no sea click 
    Array.from(document.querySelectorAll('[data-metricas="dataLayer"]'))
        .filter(d => d.getAttribute("data-metricas-type") != null && d.getAttribute("data-metricas-type") !== "" && d.getAttribute("data-metricas-type") === "click")
        .map((obj) => {
            if (obj.getAttribute("data-metricas-categoria") != null && obj.getAttribute("data-metricas-categoria") != "" && obj.getAttribute("data-metricas-etiqueta") != null && obj.getAttribute("data-metricas-etiqueta") != "") {
                // Home , Footer , Header , Nota , etc
                let categoria = obj.getAttribute("data-metricas-categoria");
                // click
                let tipoEvento = obj.getAttribute("data-metricas-type");
                // Politica, inflacion , pronostico , etc 
                let etiqueta = obj.getAttribute("data-metricas-etiqueta");
                obj.addEventListener("click",
                    () => {
                        if (window.dataLayer != undefined) {
                            window.dataLayer.push({'event':'trackEvent','eventCategory': categoria ,'eventAction':tipoEvento,'eventLabel':etiqueta,'nonInteraction':false});
                        }
                    });
            }
        });
}

export const createDatalayer = () => {
    let metaRefresh = localStorage.getItem("CDmetaRefresh");
    let usuarioLogeado = localStorage.getItem("CDusuarioLogeado");
    let credentialType = localStorage.getItem("CDcredentialType");
    let payUser = localStorage.getItem("CDpayUser");
    let suscriptorType = localStorage.getItem("CDsuscriptorType");
    let userId = localStorage.getItem("CDuserId");
    let usuarioRegistrado = localStorage.getItem("CDusuarioRegistrado");
    //   let notasLeidas = localStorage.getItem("CDnotasLeidas");
    let countNotas = localStorage.getItem("countNotas");
    let naveggObj = {};
    let navegData = localStorage.getItem("nvgpersona18894");
    if (navegData != null) {
        naveggObj = JSON.parse(navegData);
    }

    metaRefresh = metaRefresh != null ? "yes" : "no";
    usuarioLogeado = usuarioLogeado ? usuarioLogeado : "no";
    credentialType = credentialType ? credentialType : "N/A";
    payUser = payUser ? payUser : "no";
    suscriptorType = suscriptorType ? suscriptorType : "N/A";
    userId = userId ? userId : "N/A";
    usuarioRegistrado = usuarioRegistrado ? usuarioRegistrado : "no";
    //notasLeidas = notasLeidas ? notasLeidas : 0;
    countNotas = countNotas ? countNotas : 0;

    if (metaRefresh === "yes") {
        localStorage.removeItem("CDmetaRefresh");
    }
    let datalayerDom = document.querySelector('div[data-layer]');
    window.dataLayer = [
        {
            "metarefresh": metaRefresh,
            "pageType": datalayerDom.getAttribute('data-pageType').toString(),
            "mainTag": datalayerDom.getAttribute('data-mainTag').toString(),
            "tags": datalayerDom.getAttribute('data-tags').toString(),
            "autor": datalayerDom.getAttribute('data-autor').toString(),
            "seccion": datalayerDom.getAttribute('data-seccion').toString(),
            "longitud": datalayerDom.getAttribute('data-longitud').toString(),
            "formato": datalayerDom.getAttribute('data-formato').toString(),
            "genero": datalayerDom.getAttribute('data-genero').toString(),
            "tematica": datalayerDom.getAttribute('data-tematica').toString(),
            "valor": datalayerDom.getAttribute('data-valor').toString()
        }
    ];
    window.dataLayer[0].usuarioLogeado = usuarioLogeado;
    window.dataLayer[0].credentialType = credentialType;
    window.dataLayer[0].payUser = payUser;
    window.dataLayer[0].suscriptorType = suscriptorType;
    window.dataLayer[0].userId = userId;
    window.dataLayer[0].usuarioRegistrado = usuarioRegistrado;
    ///TODO : Pasar a configuracion, no se hace ahora porq se pide con urgencia.
    var navegItems = ["age", "career", "city", "country", "income", "education", "gender", "industry", "interest", "marital"];
    for (let itemProp of navegItems) {
        if (naveggObj.hasOwnProperty(itemProp)) {
            window.dataLayer[0][itemProp] = naveggObj[itemProp];
        } else {
            window.dataLayer[0][itemProp] = "N/A";
        }
    }

    if (datalayerDom.getAttribute('data-pageType').toString() === "nota") {
        window.dataLayer[0].notasLeidas = countNotas;
        // dataLayer[0].countNotas = countNotas;
    }

    function clean(obj) {
        var propNames = Object.getOwnPropertyNames(obj);
        for (let i = 0; i < propNames.length; i++) {
            let propName = propNames[i];
            if (obj[propName] === "" || obj[propName] === null || obj[propName] === undefined || obj[propName] === "0") {
                delete obj[propName];
            }
        }
    }
    clean(window.dataLayer[0]);

}

export const googleOptimazerHead = () => {
    (function(a,s,y,n,c,h,i,d,e){s.className+=' '+y;
        h.end=i=function(){s.className=s.className.replace(RegExp(' ?'+y),'')};
        (a[n]=a[n]||[]).hide=h;setTimeout(function(){i();h.end=null},c);
    })(window, document.documentElement, 'async-hide', 'dataLayer', 4000, { 'GTM-GHV6': true });
}

export const tagManagerHead = () => {
    (function (w, d, s, l, i) {
        w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true; j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-GHV6');
}



// WEBPACK FOOTER //
// ./Statics/scripts/common/analytics/MetricsEvents.js